import {Box} from "@amzn/awsui-components-react-v3";

export function EmptyState({ title, subtitle, action }) {
    return (
        <Box textAlign="center" color="inherit">
            <Box variant="strong" textAlign="center" color="inherit">
                {title}
            </Box>
            <Box variant="p" padding={{ bottom: 's' }} color="inherit">
                {subtitle}
            </Box>
            {action}
        </Box>
    );
}


// WEBPACK FOOTER //
// ./src/components/reports/components/common/EmptyState.jsx